<template lang="pug">
  include ./../../mixins
  +b.BUTTON.button(@click.prevent="openReviewModal") {{ _("Add review") }}
</template>

<script>
import ReviewModal from '@/js/components/Modals/Review'
export default {
  props: {
    url: String,
  },
  methods: {
    openReviewModal() {
      this.$modal.show(ReviewModal, {
        url: this.url
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Common/ReviewCreateButton.vue